<!-- 月票预下单 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNoColor": 5,
                "carNo": "粤YY55555",
                "phone": "13888888888",
                "num": 1,
                "monthBillId": 132888,
                "thirdpartyBillCode": "230630151128hYY55555cf",
                "startTime": "20230801000000",
                "endTime": "20230831235959",
                "monthTicketConfigId": 9626,
                "thirdpartyIdentify": "abc",
                "parkCodes": [
                    "2KW7CYBB"
                ]
            },
            responseCode: {
                "data": {
                    "failExplain": "ok",
                    "open": true,
                    "shouldBillValue": 0.01
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 ydtw购买月票-月票数量扣减",
                t_url: this.commonUrls.test+"deductMonthTicketConfig",
                p_url: this.commonUrls.prod+"deductMonthTicketConfig",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                          { info1: 'parkCodes', info2: '是', info3: 'JSONArray', info4: '停车场编码列表，建议只传一个车场编码，即月票的财务主体车场编码' },
                          { info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号码' },
                          { info1: 'carNoColor', info2: '否', info3: 'Integer', info4: '车牌号码颜色，当车牌为月票预约车牌时生效，<url>参考附录:/Api/appendixData#appendixData_7</url>' },
                          { info1: 'phone', info2: '否', info3: 'String', info4: '手机号码，11位，购买月票时的手机号码' },
                          { info1: 'userUniqueCode', info2: '否', info3: 'String', info4: '用户唯一编码' },
                          { info1: 'num', info2: '否', info3: 'Integer', info4: '开通数量，大于0，默认1' },
                          { info1: 'monthBillId', info2: '否', info3: 'Long', info4: '续费月票ID，续费时必填' },
                          { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型ID' },
                          { info1: 'thirdpartyBillCode', info2: '是', info3: 'String', info4: '开通方锁定账单号' },
                          { info1: 'thirdpartyIdentify', info2: '是', info3: 'String', info4: '开通方标识' },
                          { info1: 'startTime', info2: '是', info3: 'String', info4: '月票有效开始时间yyyyMMddHHmmss，如：20230801000000' },
                          { info1: 'endTime', info2: '是', info3: 'String', info4: '月票有效结束时间yyyyMMddHHmmss，如：20230831235959' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'failExplain', info2: '否', info3: 'Integer', info4: '失败描述' },
                        { info1: 'open', info2: '否', info3: 'Boolean', info4: '是否可开通，为true是表示可开通' },
                        { info1: 'shouldBillValue', info2: '否', info3: 'DECIMAL', info4: '应缴金额，单位：元' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/operation/deductMonthTicketConfig.vue